import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=544088e4&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=544088e4&prod&scoped=true&lang=css"
import style1 from "./Registration.vue?vue&type=style&index=1&id=544088e4&prod&lang=less&scoped=true"
import style2 from "./Registration.vue?vue&type=style&index=2&id=544088e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544088e4",
  null
  
)

export default component.exports